import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=63229d4c&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=63229d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63229d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63229d4c')) {
      api.createRecord('63229d4c', component.options)
    } else {
      api.reload('63229d4c', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=63229d4c&scoped=true&", function () {
      api.rerender('63229d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Notifications.vue"
export default component.exports